// extracted by mini-css-extract-plugin
module.exports = {"dragAndDropArea":"dragAndDropArea__SoXY+","success":"success__IbVvD","error":"error__YBClH","dragOver":"dragOver__OUmP+","overlay":"overlay__OvXfO","fileInput":"fileInput__C4iRJ"};